'use strict';

var ProfileChartLegendDirective = function ProfileChartLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/profile-chart-legend.html'),
    controller: 'ProfileChartLegendController',
    scope: {
      legendItems: '=',
      isCollapsible: '='
    }
  };
};
ProfileChartLegendDirective.$inject = [];
module.exports = ProfileChartLegendDirective;